import type { ProductColorOption } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useStore } from 'zustand';
import { usePhotoDraftStore } from '@/entities/edit-area';
import { FacePhotoCard } from './face-photo-card';

interface ColorFacePhotoGroupProps {
  readonly color: ProductColorOption;
}

export const ColorFacePhotoGroup = ({ color }: ColorFacePhotoGroupProps): ReactElement => {
  const store = usePhotoDraftStore();
  const activeFaces = useStore(store, (state) => state.draft.activeFaces);
  return (
    <section className="space-y-3" aria-label={`${color.name} 면 사진`}>
      <h3 className="font-semibold">
        {color.name}
        {!color.isAvailable ? ' (공급 불가)' : ''}
      </h3>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {activeFaces.map((face) => (
          <FacePhotoCard key={face} colorOptionId={color.id} colorName={color.name} face={face} />
        ))}
      </div>
    </section>
  );
};
